/* import __COLOCATED_TEMPLATE__ from './automation-card.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();